module.exports = __webpack_public_path__ + "img/spetema.88852a03.svg";